(function () {
  if (!window.Shopify || !window.Shopify.routes || !window.Shopify.routes.root) return;
  function isProductAddForm(form) {
    return form instanceof HTMLFormElement && form.matches('form[action*="/cart/add"]') && Boolean(form.querySelector('[name="id"]'));
  }
  function updateCartCount(cart) {
    var cartLink = document.querySelector('.site-header__cart');
    var badge = document.getElementById('CartCount');
    if (!cart || !cartLink) return;
    if (!cart.item_count) {
      if (badge) badge.remove();
      return;
    }
    if (!badge) {
      badge = document.createElement('div');
      badge.id = 'CartCount';
      badge.className = 'site-header__cart-count';
      var number = document.createElement('span');
      badge.appendChild(number);
      cartLink.appendChild(badge);
    }
    var count = badge.querySelector('span');
    if (count) count.textContent = String(cart.item_count);
  }
  function showNotice(message, isError) {
    var notice = document.getElementById('CartlyTestAddNotice');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'CartlyTestAddNotice';
      notice.style.cssText = 'position:fixed;top:1rem;left:1rem;right:1rem;z-index:2147483000;max-width:32rem;margin:0 auto;padding:1rem 1.25rem;background:#171717;color:#fff;border-radius:.5rem;box-shadow:0 4px 18px rgba(0,0,0,.25);font:600 15px/1.4 sans-serif;display:flex;align-items:center;justify-content:space-between;gap:1rem;';
      document.body.appendChild(notice);
    }
    notice.textContent = '';
    notice.setAttribute('role', isError ? 'alert' : 'status');
    notice.setAttribute('aria-live', isError ? 'assertive' : 'polite');
    var text = document.createElement('span');
    text.textContent = message;
    notice.appendChild(text);
    var link = document.createElement('a');
    link.href = window.Shopify.routes.root + 'cart';
    link.textContent = window.cartlyTestStrings.viewCart;
    link.style.cssText = 'color:#ffd7fb;text-decoration:underline;white-space:nowrap;';
    notice.appendChild(link);
    window.clearTimeout(window.cartlyTestNoticeTimer);
    window.cartlyTestNoticeTimer = window.setTimeout(function () { notice.remove(); }, 6500);
  }
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!isProductAddForm(form)) return;
    if (event.submitter && event.submitter.name !== 'add') return;
    if (form.dataset.ajaxSubmitting === 'true') return;
    event.preventDefault();
    form.dataset.ajaxSubmitting = 'true';
    var button = event.submitter || form.querySelector('button[name="add"]');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
    try {
      var addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      var addedItem = await addResponse.json();
      if (!addResponse.ok) throw new Error(addedItem.description || window.cartlyTestStrings.addError);
      try {
        var cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) updateCartCount(await cartResponse.json());
      } catch (cartReadError) {}
      showNotice(window.cartlyTestStrings.added, false);
    } catch (error) {
      showNotice(window.cartlyTestStrings.addError, true);
    } finally {
      delete form.dataset.ajaxSubmitting;
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  }, true);
})();